export interface DeadZoneMetricModel {
  map: string;
  rg: number;
  d: number;
  val: number;
  hr: string;
  singleHr: DeadZoneThreshold;
}

export default class DeadZoneMetric {
  map: string;
  rg: number;
  d: number;
  val: string;
  hr: string;
  singleHr: DeadZoneThreshold;

  constructor(model: DeadZoneMetricModel) {
    this.map = model.map;
    this.val = model.val.toFixed(2);
    this.d = model.d;
    this.rg = model.rg;
    this.hr = model.hr;
    this.singleHr = model.singleHr;
  }
}

export enum DeadZoneThreshold {
  None = 'None',
  Light = 'Light',
  Medium = 'Medium',
  Heavy = 'Heavy',
  Severe = 'Severe',
}

export const DEAD_ZONE_GRADE_MARKS: DeadZoneThreshold[] = [
  DeadZoneThreshold.Severe,
  DeadZoneThreshold.Heavy,
  DeadZoneThreshold.Medium,
  DeadZoneThreshold.Light,
  DeadZoneThreshold.None,
];
